//@flow
import React from 'react';
import FilterPill from './FilterPill.react';
import FilterClear from './FilterClear.react';
import type { Filter } from '../../Stores/Filters/filtersStoreClass';

type Props = {
  selectedFilters:Filter[],
};

function _renderClearBtn(props:Props) {
  if (props.selectedFilters.length <= 0) return null;
  return <FilterClear>Clear all</FilterClear>;
}

function _renderPills(props:Props) {
  return props.selectedFilters.map(
    filter => <FilterPill name={filter.name} text={filter.text} key={filter.name} />
  );
}

export default function FilterPills(props:Props) {
  return (
    <div className="filter-pills">
      {_renderPills(props)}
      {_renderClearBtn(props)}
    </div>
  );
}
